import React, { Component } from "react";
import {RecaptchaWindow} from "../types/Types";
import {recaptchaHtmlId} from "../utils/constants";
import classNames from "classnames";

const recaptchaWindow: RecaptchaWindow = window as RecaptchaWindow;

interface RecaptchaState {
  isReady: boolean;
}

export interface RecaptchaProps {
  onLoad: (recaptchaId: number) => void;
  visible: boolean;
}

export default class Recaptcha extends Component<RecaptchaProps, RecaptchaState> {

  private readyInterval: number;
  private id: number = 0;

  constructor(props: RecaptchaProps) {
    super(props);

    this.state = {
      isReady: false
    }

    this.updateReadyState = this.updateReadyState.bind(this);

    this.readyInterval = window.setInterval(() => {
      this.updateReadyState();
    }, 500);
  }

  componentDidUpdate(prevProps: RecaptchaProps, prevState: RecaptchaState) {
    if (!prevState.isReady && this.state.isReady) {
      this.id = recaptchaWindow.grecaptcha.render(recaptchaHtmlId, {
        "sitekey": process.env.REACT_APP_RECAPTCHA_SITEKEY
      });
      this.props.onLoad(this.id);
    }
  }

  componentWillUnmount() {
    window.clearInterval(this.readyInterval);
  }

  updateReadyState() {
    if (this.isReady()) {
      this.setState({
        isReady: true
      });
      window.clearInterval(this.readyInterval);
    }
  }

  isReady(): boolean {
    return typeof recaptchaWindow.grecaptcha !== "undefined";
  }

  render() {
    const recaptchaClasses = classNames({
      hidden: !this.props.visible,
      "g-recaptcha": this.state.isReady
    });

    return (
      <div>
        <div id={recaptchaHtmlId} className={recaptchaClasses}></div>
      </div>
    )
  }
}
